import {existingCustomerSelected, queryBearerToken} from "./UserAuthentication";
import {queryArticleOptionData} from "./ArticleData";
import {agencyServerProjectArticles, cmsArticles, shopArticles} from "../config/Config";
import {appInitialized} from "./AppInit";
import {putFormData} from "./FormData";
import {isMode} from "../selectors/Mode";
import {APP_MODE_OUTSOURCING} from "../constants/General";
import {queryCustomerAccounts} from "./Accounts";
import {_account, _customerNumber} from "../selectors/GetParam";
import {queryNewCart} from "./Cart";
import {OUTSOURCING_TARGET} from "../constants/StepLabels";
import {queryCustomerResellers} from "./Resellers";
import {delve} from "../util/util";
import {selectCurrentProduct} from "./BaseArticle";
import {getSoftwareLoaders} from "./AppInit.SoftwareLoaders";
import {queryCustomerContracts} from "./Contracts";
import {getCurrentAccountByContract} from "../selectors/Accounts";
import {getContractBillingPeriodNormalized} from "../selectors/Contract";
import {selectCartProperty} from "./Properties";

export const initializeAppOutsourcing = (initParams) => (dispatch, getState) => {

    const articleDataToLoad = [
        ...cmsArticles,
        ...shopArticles,
        ...agencyServerProjectArticles
    ];

    Promise.all([

        dispatch(queryBearerToken())

    ]).then(args => {

        Promise.all([

            dispatch(queryNewCart()),
            ...getSoftwareLoaders().map(func => dispatch(func)),
            dispatch(queryCustomerAccounts(_customerNumber)),
            dispatch(queryCustomerContracts(_customerNumber)),
            dispatch(queryCustomerResellers(_customerNumber))

        ]).then(args => {

            const currentAccount = getCurrentAccountByContract(getState());
            const accounts = getState().accounts;
            const currentArticle = delve(accounts, currentAccount + ".article.articleNumber");
            const postInitCalls = []

            const billingPeriodStart = getContractBillingPeriodNormalized(getState());

            postInitCalls.push(selectCartProperty('billingPeriod', billingPeriodStart));
            postInitCalls.push(existingCustomerSelected())

            if (currentAccount && currentAccount.backupRange) {
                postInitCalls.push(selectCartProperty('backupRange', currentAccount.backupRange));
            }

            if (articleDataToLoad.indexOf('' + currentArticle) === -1) {
                articleDataToLoad.push('' + currentArticle);
            }

            postInitCalls.push(queryArticleOptionData(articleDataToLoad))


            Promise.all(postInitCalls.map(func => dispatch(func))).then(args => {
                dispatch(selectCurrentProduct("" + currentArticle, currentAccount))
                dispatch(appInitialized({...initParams, initialStep: OUTSOURCING_TARGET}))
                dispatch(putFormData())
            })

        });
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.Outsourcing.js
 **/